import { getCopy } from 'lib/utils/getCopy';
import { FC } from 'react';
import { DictionaryItem } from 'types/Dictionary';
import { ContainerButtons } from './styles';
import { IMGIcon, PDFIcon } from "../../Icons/icons";
import { CorporateButton } from "./../../CorporateButton";

interface DownloadAreaProps {
  pressRelease: any;
  copy: DictionaryItem[];
}
const DownloadArea: FC<DownloadAreaProps> = ({ pressRelease, copy }) => {
  return (
    <ContainerButtons>
      {pressRelease?.downloadPr && (
        <a href={pressRelease?.downloadPr?.url} target="_blank" rel="noreferrer">
          <CorporateButton
            color="tertiary"
            type="lead"
            icon={<PDFIcon />}
            label={getCopy('download_press_news', copy)}
          />
        </a>
      )}
      {pressRelease?.downloadImage && (
        <a href={pressRelease?.downloadImage?.url} target="_blank" rel="noreferrer">
          <CorporateButton
            color="tertiary"
            type="lead"
            icon={<IMGIcon />}
            label={getCopy('download_image_material', copy)}
          />
        </a>
      )}
    </ContainerButtons>
  );
};

export default DownloadArea;
